export const state = {
    ipAddressList: [],
    loginInfo: [],


}


// WEBPACK FOOTER //
// ./src/plugins/userOperation/provider/store-addons/state.js